$(function () {
    'use strict';

    // catalog
    var $catalogSections = $('.profile-management__catalog__rates');
    var $changeCatalogPositionInput = $('.profile-management__catalog__position-input', $catalogSections);
    var $changeCatalogRateInput = $('.profile-management__catalog__rate-input', $catalogSections);
    $changeCatalogPositionInput.on('InputWithPlusMinus::Change', function(e, newValue, action) {
        if (action == 'set-calculated') {
            return;
        }
        var $positionHolder = $(this);
        var $rateHolder = $positionHolder.closest($catalogSections).find($changeCatalogRateInput);
        var $positionInput = $positionHolder.find('input');
        var $rateInput = $rateHolder.find('input');

        $positionInput.prop('disabled', true);
        $rateInput.prop('disabled', true);

        var url = $positionHolder.data('calc-rate-url');
        var rate = $rateInput.val() - 0;
        var position = $positionInput.val() - 0;

        var request_url = url;
        if (typeof action == 'undefined') {
            request_url += '&position=' + position;
        } else {
            var d = action == 'plus' ? 'down' : 'up';
            request_url += '&d=' + d + '&r=' + rate;
        }

        $.get(request_url, function(data) {
            var rate = data.rate;
            var position = data.position;

            $rateInput.val(rate).trigger('change', ['set-calculated']).prop('disabled', false);
            $positionInput.val(position).trigger('change', ['set-calculated']).prop('disabled', false);
        }, 'json');
    });

    $changeCatalogRateInput.on('InputWithPlusMinus::Change', function(e, newValue, action) {
        if (action == 'set-calculated') {
            return;
        }
        var $rateHolder = $(this);
        var $positionHolder = $rateHolder.closest($catalogSections).find($changeCatalogPositionInput);
        var $positionInput = $positionHolder.find('input');
        var $rateInput = $rateHolder.find('input');

        $positionInput.prop('disabled', true);
        $rateInput.prop('disabled', true);

        var url = $rateHolder.data('calc-position-url');
        var rate = $rateInput.val() - 0;
        $.get(url + rate, function(data) {
            $positionInput.val(data).trigger('change', ['set-calculated']).prop('disabled', false);
            $rateInput.prop('disabled', false);
        });
    });
});